import { Box, Image } from "@salestrak/ui";
import asset_white_logo from "#app/assets/images/white-logo.png";

export function SplashScreen() {
  return (
    // The splash is theme-independent brand chrome: it paints before the theme
    // class settles, and its logo asset is the white one unconditionally. The
    // old hard-coded near-black literal is replaced by scoping the dark token
    // set to this subtree (`dark` class) and painting the background token —
    // same pixels, no literal color in app code.
    <Box
      zIndex={50} position="fixed"
      inset={0}
      direction="column"
      align="center"
      justify="center"
      background="background"
      className="dark"
    >
      <Box opacity={80} width={48} height={48}>
        <Image src={asset_white_logo} alt="" fill fit="contain" />
      </Box>
    </Box>
  );
}
